import { Box, Button, type ButtonProps, type Theme, type SxProps, useTheme } from "@mui/material";
import { imageURL } from "../http";
import type { Image } from "./carousel/Carousel";
import { rgbToHex } from "../util";

// @ts-expect-error
export interface BrandButtonProps extends ButtonProps {
    image?: Image;
    multiple?: boolean;
    color?: "light" | "dark" | string;
}

export const BrandButton = ({
    color = "light",
    image = { src: "", title: "" },
    multiple = false,
    sx = {},
    children,
    ...rest
}: BrandButtonProps): JSX.Element => {
    const { src, title, color: brandColor } = image;
    const t = useTheme();
    return (
        <>
            <Button
                sx={
                    {
                        ...sx,
                        padding: 0,
                        position: "relative",
                        zIndex: 1,
                        "&::before, &::after": multiple
                            ? { ...bf, boxShadow: t.palette.mode === "dark" ? `2px 2px rgba(255,255,255,0.5)` : `2px 2px rgba(0,0,0,0.5)` }
                            : {},
                        "&::after": multiple ? { left: -1, top: -4, transform: "rotate(-2deg)" } : {},
                    } as SxProps
                }
                {...rest}
            >
                {src ? (
                    <Box
                        component="img"
                        src={src ? imageURL(src) : ""}
                        alt={title}
                        sx={t => ({
                            ...css(t, brandColor ? rgbToHex(brandColor): t.palette.mode),
                            "&:hover": { backdropFilter: "blur(20px);" },
                        }) as any}
                        crossOrigin="anonymous"
                        draggable={false}
                        fetchPriority="high"
                    />
                ) : (
                    <Box sx={t => css(t, color) as any} draggable={false}>
                        {children}
                    </Box>
                )}
            </Button>
        </>
    );
};

const bf = {
    content: "''",
    width: 94,
    height: 52,
    position: "absolute",
    borderRadius: "0 4px 4px 0",
    left: -3,
    top: -3,
    transform: "rotate(1deg)",
    zIndex: -1,
} as SxProps;

function css(theme: Theme, color: "light" | "dark" | string): SxProps<Theme> {
    const backgroundColor = color === "light" ? "#fff" : color === "dark" ? theme.palette.grey[800] : color;
    return {
        width: 90,
        height: 48,
        position: "relative",
        objectFit: "contain",
        backgroundColor,
        borderRadius: "4px 0px 4px 0px",
        boxShadow: `var(--mui-shadows-2)`,
        fontSize: "1.1rem",
        fontWeight: 900,
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "center",
        color: theme.palette.getContrastText(backgroundColor),
        overflow: "hidden"
    };
}
